import { render, staticRenderFns } from "./MineAccount.vue?vue&type=template&id=20fe9700&scoped=true"
import script from "./MineAccount.vue?vue&type=script&lang=js"
export * from "./MineAccount.vue?vue&type=script&lang=js"
import style0 from "./MineAccount.vue?vue&type=style&index=0&id=20fe9700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe9700",
  null
  
)

export default component.exports